import type { ReactNode } from "react";
import type { AnnotationLabelOption } from "./annotationLabels";
import { classNames } from "../../ui/styles/classNames";
import { FORM_SELECT_CLASS } from "../../ui/styles/formStyles";

interface AnnotationEditControlsProps {
  /** The annotated or selected text. */
  value: string;
  type: string;
  options: readonly AnnotationLabelOption[];
  nameOf: (type: string) => string;
  selectLabel: string;
  disabled?: boolean;
  onChangeType: (type: string) => void;
  /** Delete for an annotation, add for a new selection. */
  children: ReactNode;
}

/** Below the span editor in edit mode: the chosen text, its label, and what to do with it. */
export default function AnnotationEditControls({ value, type, options, nameOf, selectLabel, disabled = false, onChangeType, children }: AnnotationEditControlsProps) {
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2">
      <span className="app-text-muted max-w-[18rem] truncate text-xs" title={value}>
        {value}
      </span>
      <select
        aria-label={selectLabel}
        value={type}
        disabled={disabled}
        onChange={(event) => { onChangeType(event.target.value); }}
        className={classNames(FORM_SELECT_CLASS, "h-8 py-1 pr-8 text-xs")}
        style={{ width: "12rem" }}
      >
        {options.map((label) => (
          <option key={label.name} value={label.name}>
            {nameOf(label.name)}
          </option>
        ))}
      </select>
      {children}
    </div>
  );
}
